<template>
  <script
    v-once
    type="application/javascript"
    id="hs-script-loader"
    async
    defer
    src="//js.hs-scripts.com/7980359.js"
  ></script>
</template>

<script>
import isMobile from "PublicHelpers/isMobile";
import isTablet from "PublicHelpers/isTablet";

export default {
  name: "HubspotChatBot",
  data() {
    return {
      excludedPartialUrls: ["/social"],
      isMobile: false,
      isTablet: false,
      updateTask: null,
      resizeTask: null,
      widgetActive: false,
      container: null,
    };
  },
  computed: {
    currentUrlExcluded() {
      return this.excludedPartialUrls
        .map((url) => this.$route.path.includes(url))
        .includes(true);
    },
    visible() {
      if (this.currentUrlExcluded) return false;
      return !this.isMobile;
    },
    style() {
      if (this.widgetActive && this.container) {
        let activeStyle = `height: 100%; width: 100%; visibility: ${
          this.visible ? "visible" : "hidden"
        };`;
        if (this.isTablet) return `${activeStyle} bottom: 65px !important`;
        return activeStyle;
      }
      if (!this.widgetActive && this.container) {
        const baseStyle = `height: 80px; width: 80px; visibility: ${
          this.visible ? "visible" : "hidden"
        };`;
        if (this.isMobile) return `${baseStyle} bottom: 45px !important`;
        if (this.isTablet) return `${baseStyle} bottom: 65px !important`;
        return baseStyle;
      }
      return "visibility: hidden";
    },
  },
  methods: {
    updateStyles() {
      this.isMobile = isMobile();
      this.isTablet = isTablet();
      this.widgetActive = !!document.querySelector(".shadow-container.active");
      this.container = document.querySelector(
        "#hubspot-messages-iframe-container"
      );
      if (!!this.container) {
        this.container.setAttribute("style", this.style);
      }
    },
    update() {
      if (this.resizeTask) clearTimeout(this.resizeTask);
      this.resizeTask = setTimeout(() => {
        this.updateStyles();
      }, 750);
    },
  },
  created() {
    window.addEventListener("resize", this.update);
    this.updateStyles();
  },
  mounted() {
    this.updateTask = setInterval(() => {
      this.updateStyles();
    }, 500);
  },
  beforeDestroy() {
    clearInterval(this.updateTask);
    clearTimeout(this.resizeTask);
    window.removeEventListener("resize", this.update);
  },
};
</script>

<style scoped></style>
